import "./ContactBoxStyle.scss";
import { IJSLComponent, IJSLVNode } from "jsl-render";

export class ContactBoxComponent implements IJSLComponent {

    public render(): IJSLVNode {
        return  <div class="contact-box">
        <table>
            <tr>
                <td>
                    Website:
                </td>
                <td>
                    <a href="https://nivona.com" alt="">nivona.com</a>
                </td>
            </tr>
            <tr>
                <td>
                    EMail:
                </td>
                <td>
                    <a href="mailto:service@nivona.com" alt="">service@nivona.com</a>
                </td>
            </tr>
            <tr>
                <td>
                    Telefonnummer:
                </td>
                <td>
                    <a href="tel:0911-252663 - 90" alt="">0911-252663 - 90</a>
                </td>
            </tr>
            <tr>
                <td colspan="2" style="text-align:center">(Mo-Fr 8:00 - 17:00 Uhr)</td>
            </tr>
        </table>
    </div>;
    }

}
